
export const getWishList = (query) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }
  return fetch('/shared/api/getWishList', requestOptions).then((response) => response.json())
}


export const tourMasterInPackage = (query) => {
  console.log("query in tourMasterInPackage",query)
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },

  }
  return fetch(`/shared/api/getTourmasterInPackage?id=${query.id}`, requestOptions).then(async (response) => {
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    });
}

// export const getTourmasterInPackage = (query) => {
//   const requestOptions = {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//       'Cache-Control': 'no-cache',
//       Pragma: 'no-cache',
//     },
//   }
//   return fetch(`api/getTourmasterInPackage?id=${query.id}`, requestOptions)
//     .then(async (response) => {
//       const text = await response.text();
//       return text ? JSON.parse(text) : {};
//     });
// }


export const getDashboard = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(query)
  }
  console.log(requestOptions)
  return fetch('/shared/api/getDashboard', requestOptions).then((response) => response.json())
}



export const handleRemoveWishlistClick = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(query)
  }
  console.log(requestOptions)
  return fetch('/shared/api/removeWishList', requestOptions).then((response) => response.json())
}
